import {Injectable} from "@angular/core";
import {AvdbCartItemJSON, CartItemJSON} from "cart-shared";
import {CartItemLinkerService} from "purchasing-shared/cart-item-linker";
import {CartItem} from "purchasing/cart/cart-item";
import {Observable} from "rxjs";
import {AvdbCartItem} from "./avdb-cart-item";
import {DatabasePricingService} from "./database-pricing.service";


@Injectable()
export class AvdbCartItemLinkerService implements CartItemLinkerService {
	constructor(
		private databasePricingService: DatabasePricingService) { }

	canLinkCartItem(cartItemJSON: CartItemJSON): cartItemJSON is AvdbCartItemJSON {
		return cartItemJSON.itemType === "avdb";
	}

	linkCartItem(cartItemJSON: CartItemJSON): Observable<CartItem> {
		if (!this.canLinkCartItem(cartItemJSON))
			return Observable.of(null);

		return this.databasePricingService
			.getAvdbPricingForDevices([cartItemJSON.deviceID], cartItemJSON.partNumber)
			.map(pricing => {
				let device = pricing.devices.find(d => d.id === cartItemJSON.deviceID);
				if (device == null)
					return null;

				let product = device.allProducts.find(p => p.partNumber === cartItemJSON.partNumber);
				if (product == null)
					return null;

				return new AvdbCartItem({product, device});
			});
	}
}
